import { Link, useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { ReceiptSketch } from "../components/Decor";
import { Wordmark } from "../components/Brand";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#0B1F33] text-white relative overflow-hidden" data-testid="payment-cancel-page">
      <div aria-hidden className="absolute inset-0 pat-grid-ink opacity-40" />
      <div aria-hidden className="absolute -top-10 -right-10 opacity-30"><ReceiptSketch w={220} tone="dark" /></div>
      <div className="relative max-w-6xl mx-auto w-full px-5 py-6">
        <Link to="/aujourdhui" className="flex items-center gap-2 w-fit">
          <Wordmark tone="dark" size="md" />
        </Link>
      </div>
      <div className="relative min-h-[72vh] flex items-center justify-center px-5 pb-12">
        <div className="w-full max-w-md rounded-xl border border-[#CDD7E3] bg-white p-8 text-center shadow-[0_10px_30px_rgba(0,0,0,0.35)]">
          <div className="w-16 h-16 mx-auto rounded-full bg-[#FDECEC] flex items-center justify-center">
            <XCircle className="w-8 h-8 text-[#D94A4A]" />
          </div>
          <h1 className="mt-5 text-[22px] font-heading font-bold text-[#111111]">Paiement annulé</h1>
          <p className="mt-2 text-[13.5px] text-[#5E6875]">
            Vous n'avez pas été débité. Vous pouvez réessayer à tout moment depuis vos paramètres.
          </p>
          <div className="mt-5 flex gap-2 justify-center">
            <button onClick={() => nav("/parametres")} className="h-11 px-6 rounded-md text-[#111111] text-[13.5px] font-semibold bg-[#FF9F1C] hover:bg-[#F58F06]">
              Retour aux paramètres
            </button>
            <button onClick={() => nav("/aujourdhui")} className="h-11 px-6 rounded-md border border-[#CDD7E3] bg-white text-[13.5px] font-medium text-[#111111]">
              Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
